import { Link } from "react-router-dom";

const STATS = [
  { num: "12000+", label: "收录番剧" },
  { num: "全类型", label: "动画/剧场/OVA" },
  { num: "7×24", label: "新番同步" },
  { num: "0广告", label: "点开即看" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
      {/* bg image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20dreamy%20hillside%20town%20under%20a%20sky%20full%20of%20drifting%20cherry%20blossom%20petals%20and%20a%20giant%20glowing%20moon%2C%20silhouette%20of%20sakura%20trees%2C%20warm%20pink%20and%20gold%20light%2C%20cinematic%20stylized%20illustration&width=1600&height=900&seq=hero-main-sakura&orientation=landscape"
          alt="樱花看番 樱花飘落的动画小镇"
          title="樱花看番 首屏主视觉"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-50" />
      </div>

      {/* content */}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1 text-xs text-accent-300">
            <i className="ri-sparkling-2-fill" />
            番剧库全收录 · 剧场版 / OVA / 泡面番 / 国漫
          </span>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
            樱花看番
            <span className="block text-2xl font-body font-normal text-foreground-300 md:text-3xl">
              点开即看全集，找番更方便
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            樱花看番番剧库全收录，涵盖动画、剧场版、OVA、泡面番及国漫全类型。剧场版与OVA同步更新，热门新番第一时间上线，海量经典一网打尽。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-play-circle-fill text-lg" />
              立即开播
            </a>
            <Link
              to="/library"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-300/40 bg-foreground-950/10 px-7 py-3.5 text-sm font-medium text-foreground-950 backdrop-blur-sm transition-colors hover:bg-foreground-950/20"
            >
              浏览番剧库
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* stats */}
          <dl className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {STATS.map((s) => (
              <div
                key={s.label}
                className="rounded-lg border border-background-300/40 bg-foreground-950/5 px-4 py-3 backdrop-blur-sm"
              >
                <dt className="order-2 mt-1 text-xs text-foreground-500">{s.label}</dt>
                <dd className="font-heading text-xl text-accent-300">{s.num}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}